export const GET_PAGE_IMAGES = 'images/page/get';
export const GET_PAGE_TITLES = 'titles/page/get';
export const GET_PAGE_DESCRIPTIONS = 'descriptions/page/get';